const requestCadModelForm = () => ({
    ...window.helpers,
    name: '',
    email: '',
    fieldKeys: ['name', 'email'],
    submitForm() {
        const action = '/api/requestcadmodel'

        this.initAndExecuteGoogleCaptcha(action).then((token) => {
            const formData = new FormData()

            formData.append('captcha_token', token)
            formData.append('captcha_action', action)
            formData.append('name', this.name)
            formData.append('email', this.email)

            this.submitting = true
            this.errors = {}

            window.api.post(action, formData).then((response) => {
                if (response.data.success === true) {
                    this.submitting = false
                    this.successfulSubmission = true
                    this.name = ''
                    this.email = ''
                    this.errors = {}
                } else {
                    this.processServersideErrors(response.data)
                }
            }).catch((error) => {
                this.submitting = false
                this.successfulSubmission = false
                this.processServersideErrors(error.response.data)
            })
        })
    },
})
document.addEventListener('alpine:init', () => {
    window.Alpine.data('requestCadModelForm', requestCadModelForm)
})
